import { render } from "./PostSearch.vue?vue&type=template&id=20db0dc3&ts=true"
import script from "./PostSearch.vue?vue&type=script&lang=ts"
export * from "./PostSearch.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__